import React from "react";
import { CHeader, CToggler, CHeaderBrand, CHeaderNav } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useHistory } from "react-router-dom";

import { useApp } from "context/appContext";

import elcamino from "../assets/image/elcamino-black.png";

const TheHeader = ({ hideMenu }) => {
  const history = useHistory();
  const { sidebarShow, setSidebarShow } = useApp();

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    setSidebarShow(val);
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    setSidebarShow(val);
  };

  const handleLogoout = () => {
    localStorage.removeItem("utk");
    history.push("/login");
  };

  return (
    <CHeader>
      {!hideMenu && (
        <>
          <CToggler
            inHeader
            className="ml-md-3 d-lg-none"
            onClick={toggleSidebarMobile}
          />
          <CToggler
            inHeader
            className="ml-3 d-md-down-none"
            onClick={toggleSidebar}
          />
          <CHeaderBrand className="mx-auto d-lg-none" to="/">
            <CIcon name="logo" height="48" alt="Logo" src={elcamino} />
          </CHeaderBrand>
        </>
      )}

      <CHeaderNav className="d-md-down-none mr-auto" />

      <CHeaderNav
        style={{ cursor: "pointer" }}
        onClick={handleLogoout}
        className="px-3"
      >
        Salir
      </CHeaderNav>
    </CHeader>
  );
};

export default TheHeader;
